import { render } from "./Hero.vue?vue&type=template&id=7424f8fc"
import script from "./Hero.vue?vue&type=script&lang=js"
export * from "./Hero.vue?vue&type=script&lang=js"

import "./Hero.vue?vue&type=style&index=0&id=7424f8fc&lang=css"
script.render = render

export default script